import React from 'react';

const Quote = () => (
  <h1 className="Quote" title="quote">
    We will always have STEM with us.
    Some things will drop out of the public eye and go away, but there will always be science,
    engineering, and technology.
    And there will always, always be mathematics.
    — Katherine Johnson, African-American mathematician
  </h1>
);

export default Quote;
